(function () {
  if (window.MagazineHeaderNavigation) {
    window.MagazineHeaderNavigation.init(document);
    return;
  }

  const contextKeys = ['preview_theme_id', 'preview_key', '_fd', 'pb', 'locale', 'country', 'language'];

  function archiveUrl(filter) {
    const url = new URL(filter.dataset.magArchiveUrl, window.location.origin);
    const current = new URL(window.location.href);
    contextKeys.forEach((key) => {
      if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    });
    return url;
  }

  function setSearchOpen(search, open) {
    search.classList.toggle('is-open', open);
    search.querySelector('[data-mag-header-search-toggle]').setAttribute('aria-expanded', String(open));
    search.querySelector('[data-mag-header-search-panel]').hidden = !open;
  }

  function closeAll(except, restoreFocus = false) {
    document.querySelectorAll('[data-mag-header-filter][open]').forEach((filter) => {
      if (filter === except) return;
      const focusInside = filter.contains(document.activeElement);
      filter.open = false;
      if (restoreFocus && focusInside) filter.querySelector('[data-mag-header-toggle]')?.focus();
    });
    document.querySelectorAll('[data-mag-header-search].is-open').forEach((search) => {
      if (search === except) return;
      const focusInside = search.contains(document.activeElement);
      setSearchOpen(search, false);
      if (restoreFocus && focusInside) search.querySelector('[data-mag-header-search-toggle]')?.focus();
    });
  }

  const searchSyncs = new WeakMap();

  function cleanQuery(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 100)
      .replace(/^["'\u2018\u2019\u201c\u201d\s]+|["'\u2018\u2019\u201c\u201d\s]+$/g, '');
  }

  function currentQuery() {
    return cleanQuery(new URL(window.location.href).searchParams.get('q'));
  }

  function initSearch(search) {
    if (search.dataset.magHeaderSearchInit) return;
    search.dataset.magHeaderSearchInit = '1';

    const toggle = search.querySelector('[data-mag-header-search-toggle]');
    const form = search.querySelector('[data-mag-header-search-form]');
    const input = search.querySelector('[data-mag-header-search-input]');
    const panel = search.querySelector('[data-mag-header-search-panel]');
    const clear = search.querySelector('[data-mag-header-search-clear]');
    const inPlace = search.hasAttribute('data-mag-header-search-archive');
    const current = new URL(window.location.href);

    contextKeys.forEach((key) => {
      if (!current.searchParams.has(key) || form.elements[key]) return;
      const hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = key;
      hidden.value = current.searchParams.get(key);
      form.appendChild(hidden);
    });

    function syncFilled() {
      input.classList.toggle('is-filled', input.value !== '');
    }

    function syncInput() {
      if (inPlace && !search.classList.contains('is-open')) input.value = currentQuery();
      syncFilled();
    }
    searchSyncs.set(search, syncInput);
    syncInput();

    toggle.addEventListener('click', () => {
      const open = !search.classList.contains('is-open');
      // With results showing, the archive's own search field takes the focus instead of the sheet.
      if (open && inPlace && window.MagazineArchive?.focusSearch?.()) return;
      if (open) {
        syncInput();
        closeAll(search);
      }
      setSearchOpen(search, open);
      // iOS only raises the keyboard when focus happens inside the tap's own handler.
      if (open) input.focus();
    });

    input.addEventListener('input', syncFilled);
    clear?.addEventListener('click', () => {
      input.value = '';
      syncFilled();
      input.focus();
    });

    form.addEventListener('submit', (event) => {
      const query = cleanQuery(input.value);
      if (!query) {
        event.preventDefault();
        if (inPlace && currentQuery() && window.MagazineArchive?.clearSearch?.()) {
          setSearchOpen(search, false);
          return;
        }
        input.focus();
        return;
      }
      input.value = query;
      syncFilled();
      setSearchOpen(search, false);
      if (inPlace && window.MagazineArchive?.search?.(query)) event.preventDefault();
    });

    panel.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab') return;
      const focusable = panel.querySelectorAll('input:not([type="hidden"]), button');
      const leaving = event.shiftKey ? focusable[0] : focusable[focusable.length - 1];
      if (event.target === leaving) {
        setSearchOpen(search, false);
        return;
      }
      // Wait for Tab's focus move; WebKit can blur to <main> during a tap, so focusout is not used.
      setTimeout(() => {
        if (search.classList.contains('is-open') && !panel.contains(document.activeElement)) {
          setSearchOpen(search, false);
        }
      }, 0);
    });
  }

  function init(root) {
    root.querySelectorAll('[data-mag-header-search]').forEach(initSearch);
    root.querySelectorAll('[data-mag-header-filter]').forEach((filter) => {
      if (filter.dataset.magHeaderInitialized === 'true') return;
      filter.dataset.magHeaderInitialized = 'true';

      const toggle = filter.querySelector('[data-mag-header-toggle]');
      const list = filter.querySelector('[data-mag-header-categories]');
      const status = filter.querySelector('[data-mag-header-status]');
      const retry = filter.querySelector('[data-mag-header-retry]');
      const allLink = filter.querySelector('[data-mag-header-all]');
      const url = archiveUrl(filter);
      let loading = false;
      let loaded = false;

      allLink.href = url.toString();

      async function loadCategories() {
        if (loading || loaded) return;
        loading = true;
        list.setAttribute('aria-busy', 'true');
        status.textContent = filter.dataset.loadingLabel;
        status.hidden = false;
        retry.hidden = true;

        try {
          if (!window.MagazineArchive) throw new Error('Magazine archive is unavailable.');
          const records = await window.MagazineArchive.load({
            url: url.toString(),
          });
          const categories = new Map();
          records.forEach((record) => {
            record.categories.forEach((label, index) => {
              const key = record.categoryKeys[index] || label.trim().toLowerCase();
              if (key && !categories.has(key)) categories.set(key, label);
            });
          });

          [...categories.entries()]
            .sort((left, right) =>
              left[1].localeCompare(right[1], undefined, {
                sensitivity: 'base',
              }),
            )
            .forEach(([key, label]) => {
              const categoryUrl = new URL(url);
              categoryUrl.searchParams.set('category', key);
              const item = document.createElement('li');
              item.className = 'mag-header__filter-item';
              const link = document.createElement('a');
              link.className = 'mag-header__filter-link';
              link.href = categoryUrl.toString();
              link.textContent = label;
              item.appendChild(link);
              list.appendChild(item);
            });

          loaded = true;
          status.textContent = '';
          status.hidden = true;
        } catch (error) {
          status.textContent = filter.dataset.errorLabel;
          retry.hidden = false;
        } finally {
          loading = false;
          list.removeAttribute('aria-busy');
        }
      }

      filter.addEventListener('toggle', () => {
        filter.classList.toggle('is-open', filter.open);
        toggle.setAttribute('aria-expanded', String(filter.open));
        if (filter.open) {
          closeAll(filter);
          loadCategories();
        }
      });
      retry.addEventListener('click', loadCategories);

      if (filter.open) loadCategories();
    });
  }

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-mag-header-filter], [data-mag-header-search]')) closeAll(null);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (document.querySelector('[data-mag-header-filter][open], [data-mag-header-search].is-open')) {
      event.preventDefault();
      closeAll(null, true);
    }
  });

  document.addEventListener('magazine:archive:render', () => {
    document.querySelectorAll('[data-mag-header-search-archive]').forEach((search) => {
      // Once a query is showing, the results field takes over, so the sheet never stays open beside it.
      if (currentQuery() && search.classList.contains('is-open')) setSearchOpen(search, false);
      searchSyncs.get(search)?.();
    });
  });

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  window.MagazineHeaderNavigation = { init };
  init(document);
})();
